/**
 * useIsMobile — true when viewport is below the Tailwind `lg` breakpoint
 * (1024 px). Updates on resize / orientation change.
 *
 * SSR-safe: returns `false` during the very first render, then resolves on
 * effect mount. We accept this single-flicker tradeoff for accurate state.
 */
import { useEffect, useState } from 'react';

const QUERY = '(max-width: 1023px)';

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(QUERY).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const mql = window.matchMedia(QUERY);
    const onChange = (e) => setIsMobile(e.matches);
    mql.addEventListener?.('change', onChange) ?? mql.addListener?.(onChange);
    return () => {
      mql.removeEventListener?.('change', onChange) ?? mql.removeListener?.(onChange);
    };
  }, []);

  return isMobile;
}
